import React from "react";
import Orders from "../Orders";

export default function HomeIndex() {

  return (
    <Orders />
  );
}